<template>
  <div class="w-full border border-2 p-1 rounded-lg h-[17rem]">
    <div class="d-flex gap-4">
      <div class="bg-[#FED6CE] rounded py-[2px] px-[4px]">
        <span class="k-box-search text-[#F8320A] text-3xl" />
      </div>
      <span class="font-semibold align-self-center text-[16px] text-[#626262]">PAKET HILANG</span>
      <span
        id="tooltip-lost"
        class="k-info-circle align-self-center text-xl text-[#08A0F7]"
      />
      <b-tooltip
        target="tooltip-lost"
        triggers="hover"
        variant="light"
      >
        <div class="text-start">
          <div class="mb-1">
            <b>Paket Hilang</b>
          </div>
          <div>
            Total orderan dengan status order "Hilang" (berdasarkan filter yang dipilih)
          </div>
        </div>
      </b-tooltip>
    </div>
    <div class="d-flex gap-3 mt-1 pl-1">
      <div class="font-semibold text-3xl text-black">
        <b-spinner
          v-if="count === null"
          small
          variant="primary"
        />
        <span v-else>{{ count }}</span>
      </div>
      <div
        class="align-self-center py-[3px] px-[5px] bg-[#D9E7FD] text-[#4285F4] rounded-pill text-xs"
        style="border: solid 1px #4285F4"
      >
        <b-spinner
          v-if="countOfSend === null"
          small
          variant="info"
        />
        <span v-else>{{ percent }}</span>
        <span>% dari jumlah pengiriman</span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    countOfSend: {
      type: Number,
      default: null,
    },
    date: {
      type: String,
      default: null,
    },
    shipping: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      count: null,
      percent: null,
    }
  },
  watch: {
    countOfSend(newVal) {
      if (newVal !== null) {
        this.getCount()
      }
    },
  },
  mounted() {
    this.getCount()
  },
  methods: {
    getCount() {
      const url = '/komship/api/v1/delivery-insight'
      const params = {
        metric: 'lost',
        date: this.date,
        shipping: this.shipping.shipping_name,
      }
      this.$http_new.get(url, { params })
        .then(res => {
          const { data } = res.data
          this.count = data.count
          this.percent = Number.isFinite(this.count / this.countOfSend)
            ? ((this.count / this.countOfSend) * 100).toFixed(2)
            : 0
        })
        .catch(res => {
          this.$toast_error({ message: 'Gagal Mendapatkan Data Hilang' })
        })
    },
  },
}
</script>
